import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
import './permission'
import './mock'

import { iframeMonitorMixin } from '@/mixins/iframeMonitorMixin'
import { getToken } from '@/utils/auth'
import AvueUeditor from 'avue-plugin-ueditor'
Vue.use(AvueUeditor)
Vue.mixin(iframeMonitorMixin)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts


// 屏蔽 vue-router 3 导航重定向的误报警告
const originalPush = router.__proto__.push
router.__proto__.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') return
    if (err && err.type === 2) return // NavigationRedirected
    return Promise.reject(err)
  })
}

Vue.use(ElementUI)
// Vue.use(Avue)
Vue.use(Avue, {
  size: 'small',
  tableSize: 'small',
  calcHeight: 0,
  // 你项目没用到i18n可以删掉这一行，有国际化就保留
  // i18n: (key, value) => i18n.t(key, value),
  dicHeaders() {
    const token = getToken()
    return {
      Authorization: token ? `Bearer ${token}` : ''
    }
  },
  // 上传组件统一请求头
  uploadHeaders() {
    const token = getToken()
    return {
      Authorization: token ? `Bearer ${token}` : ''
    }
  }
})

// 按钮权限指令：v-hasPermi="'sys:user:add'"
// 路由守卫保证进入页面前权限已加载，inserted 时机足够
Vue.directive('hasPermi', {
  inserted(el, binding) {
    const perms = store.getters.permissions
    if (!perms.includes(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})

// 挂载全局权限判断方法，供 JS 逻辑（非模板）使用
Vue.prototype.$hasPermi = function (perm) {
  return store.getters.permissions.includes(perm)
}

Vue.config.productionTip = false
Vue.config.errorHandler = (err) => {
  if (err && err.handled) return
  console.error(err)
}
window.addEventListener('unhandledrejection', e => {
  if (e.reason && e.reason.handled) e.preventDefault()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

